import React, { FC } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import { Link } from "react-router-dom";
interface FooterProps {}

const socialMedia = [
  { name: "facebook", icon: <FaFacebookF /> },
  { name: "twitter", icon: <FaTwitter /> },
  { name: "linkedin", icon: <FaLinkedinIn /> },
  { name: "instagram", icon: <FaInstagram /> },
];
const Footer: FC<FooterProps> = ({}) => {
  return (
    <footer className="mt-20 bg-gradient-to-b from-[#043F62] to-[#032940]">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Column 1: Services */}
          <div className="space-y-6">
            <h3 className="text-white text-lg font-bold mb-4">
              Nos Services
            </h3>
            <div className="space-y-3">
              <a
                href={process.env.REACT_APP_AQUAVESC_URL || "/"}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center text-white/80 hover:text-secondary transition-all duration-300"
              >
                <svg className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <span className="font-semibold">AQUAVESC</span>
              </a>
              <a
                href={process.env.REACT_APP_HYDREAULYS_URL || "/"}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center text-white/80 hover:text-primary transition-all duration-300"
              >
                <svg className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <span className="font-semibold">HYDREAULYS</span>
              </a>
            </div>
          </div>

          {/* Column 2: Contact */}
          <div className="space-y-6">
            <h3 className="text-white text-lg font-bold mb-4">
              Contact
            </h3>
            <div className="space-y-3 text-white/80">
              <div className="flex items-start group">
                <svg className="w-5 h-5 mr-3 mt-1 text-secondary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>12 rue Mansart – 78000 Versailles</span>
              </div>
              <div className="flex items-center group">
                <svg className="w-5 h-5 mr-3 text-primary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>01 39 23 22 60</span>
              </div>
              <div className="flex items-center group">
                <svg className="w-5 h-5 mr-3 text-secondary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
                <span>01 39 23 22 74</span>
              </div>
            </div>
          </div>

          {/* Column 3: Social Media */}
          <div className="space-y-6">
            <h3 className="text-white text-lg font-bold mb-4">
              Suivez-nous
            </h3>
            <div className="flex gap-4">
              {socialMedia.map((item, index) => (
                <a
                  key={index}
                  href="#"
                  className="group relative w-12 h-12 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm hover:bg-primary hover:scale-110 transition-all duration-300 overflow-hidden"
                >
                  {/* Shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                  <span className="text-white text-xl relative z-10">{item.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-white/60 text-sm">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
            </svg>
            <span>© 2024 eauxseineouest.fr - Tous droits réservés</span>
          </div>
          <div className="flex gap-6">
            <Link
              to="/mentions-légales"
              className="hover:text-white transition-colors duration-300 hover:underline"
            >
              Mentions légales
            </Link>
            <span className="text-white/20">|</span>
            <Link
              to="/politique-de-confidentialité"
              className="hover:text-white transition-colors duration-300 hover:underline"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
